export const DEFAULT_CURRENCIES_OPTIONS: string[] = [`BTC`, `ETH`, `USDT`, `USDC`, `SOL`, `BNB`];
